import React from "react";
import { getLocationRankings } from "services/rankingService";
import * as Sentry from "@sentry/react";

const ExportLocationRankings = ({ locationId }) => {
  const fetchExportData = async () => {
    const allRankings = await getLocationRankings(locationId);
    return allRankings;
  };

  const convertToCSV = (data) => {
    const headers = ["userId", "playerName", "ranking"];
    const rows = data.map((row) => [
      row.userId || "null",
      `"${row.playerName}"`,
      row.ranking,
    ]);

    return [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");
  };

  const downloadCSV = (content, filename) => {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = async () => {
    try {
      const data = await fetchExportData();
      if (data.length === 0) {
        alert("Aucune donnée à exporter.");
        return;
      }
      const csv = convertToCSV(data);
      downloadCSV(csv, `classement_${locationId}.csv`);
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur exportation CSV:", error);
      alert("Échec de l'export.");
    }
  };

  return (
    <button
      onClick={handleExport}
      className="bg-violet-600 hover:bg-violet-500 text-white font-semibold px-4 py-2 rounded-md"
    >
      Exporter le classement 📥
    </button>
  );
};

export default ExportLocationRankings;
